import { componentSizeMap } from '@vuesax-plus/constants'

import type { ComponentSize } from '@vuesax-plus/constants'

export const getComponentSize = (size?: ComponentSize) => {
  return componentSizeMap[size || 'default']
}
